import SharedClinicalHistoryTab from './SharedClinicalHistoryTab';
import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Tabs, Tab, Spinner, Alert, Button } from 'react-bootstrap';
import axios from 'axios';

import AlergiasTab    from './AlergiasTab';
import DocumentosTab  from './DocumentosTab';
import HistoricoTab   from './HistoricoTab';
import AnamneseViewTab from './AnamneseViewTab'; // ← ADD: 1 linha

const ProntuarioVisualizacaoModal = ({ show, onHide, paciente }) => {
    const [activeTab, setActiveTab] = useState('historico');
    const [historicoConsultas, setHistoricoConsultas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchHistorico = useCallback(async () => {
        if (!paciente?.id) return;
        setIsLoading(true);
        setError(null);
        try {
            const response = await axios.get(`/api/pacientes/${paciente.id}/consultas`, {
                params: { source: 'visualizacao' }
            });
            const sortedConsultas = (response.data.paciente.consultas || []).sort((a, b) => b.id - a.id);
            setHistoricoConsultas(sortedConsultas);
        } catch (err) {
            console.error("Erro ao buscar histórico de consultas:", err);
            setError("Não foi possível carregar o histórico do paciente.");
        } finally {
            setIsLoading(false);
        }
    }, [paciente?.id]);

    useEffect(() => {
        if (show) {
            fetchHistorico();
            setActiveTab('historico');
        } else {
            setHistoricoConsultas([]);
        }
    }, [show, fetchHistorico]);

    const renderContent = () => {
        if (isLoading && activeTab !== 'integrado') {
            return (
                <div className="text-center my-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </Spinner>
                </div>
            );
        }

        if (error && activeTab !== 'integrado') {
            return <><Alert variant="danger">{error}</Alert><Button variant="outline-primary" onClick={() => setActiveTab('integrado')}>Consultar histórico integrado</Button></>;
        }

        return (
            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                id="prontuario-visualizacao-tabs"
                className="mb-3 prontuario-view-tabs"
            >
                <Tab eventKey="integrado" title="Histórico integrado">
                    {activeTab === 'integrado' && <SharedClinicalHistoryTab key={paciente.id} patientId={paciente.id} />}
                </Tab>
                <Tab eventKey="historico" title="📋 Histórico">
                    <HistoricoTab historico={historicoConsultas} />
                </Tab>

                {/* ── ADD: Aba de Anamnese ── */}
                <Tab eventKey="anamnese" title="📝 Anamnese">
                    {/* Lazy: só renderiza quando a aba está ativa */}
                    {activeTab === 'anamnese' && (
                        <AnamneseViewTab pacienteId={paciente.id} />
                    )}
                </Tab>

                <Tab eventKey="alergias" title="⚠️ Alergias">
                    <AlergiasTab pacienteId={paciente.id} />
                </Tab>

                <Tab eventKey="laudos" title="🔬 Laudos">
                    <DocumentosTab
                        pacienteId={paciente.id}
                        tipoFiltro="Laudo"
                        readOnly={true}
                        fetchOnMount={true}
                    />
                </Tab>

                <Tab eventKey="documentos" title="📁 Documentos">
                    <DocumentosTab
                        pacienteId={paciente.id}
                        readOnly={true}
                        fetchOnMount={true}
                    />
                </Tab>
            </Tabs>
        );
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Prontuário de: {paciente?.nome || 'Carregando...'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ minHeight: '60vh' }}>
                {paciente ? renderContent() : <p>Nenhum paciente selecionado.</p>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ProntuarioVisualizacaoModal;
